import { JsonObject } from 'core/types';

export class ImpersonationClient {
  public id: string;
  public name: string;

  constructor(json: JsonObject) {
    this.id = json.clientId;
    this.name = json.description;
  }
}
